export default (typeof window !== 'undefined'
	? window
	: {
		addEventListener: () => {},
		removeEventListener: () => {},
		innerWidth: 768,
		innerHeight: 1024
	});



// WEBPACK FOOTER //
// ./state/window.js